/* src/app/shared/footer/footer.component.scss */
.footer {
  display: flex;
  justify-content: space-between;
}
/*# sourceMappingURL=footer.component.css.map */
